import { takeEvery, put } from 'redux-saga/effects';
import { GET_DATA_STORAGE, GET_DATA_FILE } from '../action';
import { getDataReportStorage, getDataReportFile } from '../../service';

function* getDataStorage({params}) {
  const { success, data } = yield getDataReportStorage(params);
 
  if (success) {
    yield put({
      type: GET_DATA_STORAGE.SUCCESS,
      data: data,
    });
  } else {
    yield put({
      type: GET_DATA_STORAGE.FAIL,
      data: data,
    });
  }
}

function* getDataFile({params}) {
  const { success, data } = yield getDataReportFile(params);
 
  if (success) {
    yield put({
      type: GET_DATA_FILE.SUCCESS,
      data: data,
    });
  } else {
    yield put({
      type: GET_DATA_FILE.FAIL,
      data: data,
    });
  }
}



export default function* () {
  yield takeEvery(GET_DATA_STORAGE.REQUEST, getDataStorage);
  yield takeEvery(GET_DATA_FILE.REQUEST, getDataFile);
}
